<template>
  <div>
    <v-data-table
      data-cy="reminders"
      :headers="headers"
      :items="excludedGroups"
      item-key="id"
      class="elevation-1 pb-6"
      no-data-text="No data to display"
      :items-per-page="15"
      :search="keyword"
      :loading="loading"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Groups</v-toolbar-title>
          <div class="flex-grow-1">
            <v-btn
              data-cy="addGroup"
              class="primary float-right"
              :loading="dialog"
              @click="addGroup()"
              >Add Group</v-btn
            >
            <AddGroup @load="loadData()" ref="group"></AddGroup>
            <v-dialog v-model="dialog" persistent width="300">
              <v-card color="primary" dark>
                <v-card-text class="pt-3 white--text">
                  Please stand by
                  <v-progress-linear
                    indeterminate
                    color="white"
                    class="mb-0"
                  ></v-progress-linear>
                </v-card-text>
              </v-card>
            </v-dialog>
          </div>
        </v-toolbar>
      </template>
      <template v-slot:item.id="{ value, item }">
        <!-- {{item.inclusionStatus}} -->
        <v-switch
          v-model="item.inclusionStatus"
          @click.stop="updateInclusionStatus(item.id)"
          inset
        ></v-switch>
        <!-- <v-btn color="primary" text :data-cy="`include${item.id}`" @click="updateInclusionStatus(value)"><v-icon>mdi-cached</v-icon></v-btn> -->
      </template>
      <template v-slot:item.inclusionStatus="{ value, item }">
        <b :class="'inclusion-' + value">{{
          !value ? "Excluded" : "Included"
        }}</b>
      </template>
      <template v-slot:item.data="{ value, item }">
        <v-btn
          color="primary"
          class="text-uppercase mr-2"
          @click.stop="updateView(item)"
          >Edit</v-btn
        >
        <v-btn
          color="error"
          class="text-uppercase"
          @click.stop="
            group = item;
            dialogActive = true;
          "
          >Delete</v-btn
        >
      </template>
    </v-data-table>
    <app-dialog
      :dialogActive="dialogActive"
      @proceed="upsertGroup"
      @cancel="cancel"
      :message="'Are you sure you want to remove this group'"
    ></app-dialog>
  </div>
</template>

<script>
import AddGroup from "@/components/dialogs/AddGroupDialog";
import { mapActions, mapGetters } from "vuex";
import ReminderGroup from "@/models/ReminderGroup";
import AppDialog from "@/components/dialogs/AppDialog";

export default {
  components: {
    AddGroup,
    AppDialog,
  },
  data: () => ({
    headers: [
      { text: "Name", value: "name", sortable: false },
      { text: "Customer Number", value: "customerNumber", sortable: false },
      { text: "Number", value: "number", sortable: false },
      { text: "Inclusion Status", value: "inclusionStatus", sortable: false },
      { text: "Toggle Inclusion", value: "id", sortable: false },
      { text: "More Actions", value: "data", sortable: false },
    ],
    reminders: [],
    excludedGroups: [],
    dialog: false,
    loading: true,
    dialogActive: false,
    group: new ReminderGroup(),
  }),
  computed: {
    ...mapGetters("search", ["keyword"]),
  },
  methods: {
    ...mapActions("reminders", [
      "updateExcludeStatus",
      "loadExcludedGroups",
      "updateGroupStatus",
    ]),

    ...mapActions("search", ["startSearch"]),
    ...mapActions("groups", ["addExcludedGroup"]),
    upsertGroup() {
      this.group.deleteAction = true;
      this.$store
        .dispatch("groups/upsertGroup", this.group)
        .then(() => {
          this.group = new ReminderGroup();
        })
        .finally(() => {
          this.loadData();
          this.dialogActive = false;
        });
    },
    cancel() {
      this.group = new ReminderGroup();
      this.dialogActive = false;
    },
    updateView(args) {
      if(!args.notice){
        args.notice = {
          courtesy: false,
          reminder1: false,
          reminder2: false,
          reminder3: false,
          restrictNotice: false
        }
      }
      this.$refs.group.group = new ReminderGroup(args);
      this.addExcludedGroup();
    },
    loadData() {
      this.$refs.group.group = new ReminderGroup();
      this.loadExcludedGroups().then((data) => {
        this.excludedGroups = data.filter((i) => i.name !== null);
        this.loading = false;
      });
    },
    updateInclusionStatus(id) {
      this.updateGroupStatus(id).then((data) => {
        let res = this.excludedGroups.filter((x) => x.id == data.id);
        this.excludedGroups.map((x) => {
          if (x.id === data.id) x.inclusionStatus = data.inclusionStatus;
        });
      });
    },
    updateExclude(item) {
      this.updateExcludeStatus(item, 0).then(() => {
        let id = this.excludedGroups.map((item) => item.id).indexOf(item.id);
        this.excludedGroups.splice(id, 1);
      });
    },
    addGroup() {
      this.addExcludedGroup();
    },
  },
  created() {
    setTimeout(() => {
      this.loadData();
    }, 100);
  },
};
</script>

<style scoped>
.inclusion-true {
  color: green;
}
.inclusion-false {
  color: red;
}
</style>
